import { render, staticRenderFns } from "./YearEdit.vue?vue&type=template&id=468caaf7&scoped=true"
import script from "./YearEdit.vue?vue&type=script&lang=ts"
export * from "./YearEdit.vue?vue&type=script&lang=ts"
import style0 from "./YearEdit.vue?vue&type=style&index=0&id=468caaf7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468caaf7",
  null
  
)

export default component.exports